export const APP_OPENED = "APP_OPENED"
export const SESSION_INFORMATION_OPENED = "SESSION_INFORMATION_OPENED"
export const CAPTIONS_SETTINGS_CHANGED = "CAPTIONS_SETTINGS_CHANGED"
